<template>
    <transition name="fade-in-tabs" mode="out-in">
        <article class="tab__content" v-if="isActive" :aria-hidden="!isActive" ref="tab">
            <slot></slot>

            <div v-if="contentHidden" class="tab__expand-toggle">
                <Button display="link" @click="toggleExpand($event)">
                    {{ expanded ? 'Show Less' : 'Show More' }}
                </Button>
            </div>
        </article>
    </transition>
</template>

<script>
import gsap from 'gsap'

export default {
    props: {
        name: { required: true }, // used for parent component
        tabReference: { type: String },
        selected: { type: Boolean, default: false },
        setMaxHeight: { type: Boolean, default: false }
    },

    data() {
        return {
            isActive: false,
            tabIndex: -1,
            maxHeight: 300,
            contentHidden: false,
            expanded: false,
            el: null
        }
    },

    watch: {
        isActive (newVal) {
            if (newVal === true) {
                if (this.setMaxHeight) this.snipContent()
            }
        },

        setMaxHeight(newVal) {
            if (this.el) {
                if (newVal) {
                    gsap.to(this.el, {
                        height: this.maxHeight,
                        duration: .4,
                        ease: 'power4.ease-out'
                    })
                    this.toggleElementStyles(true)
                } else {
                    gsap.to(this.el, {
                        height: 'auto',
                        duration: .4,
                        ease: 'power4.ease-out'
                    })
                    this.toggleElementStyles(false)
                }
            }
        }
    },

    mounted () {
        this.isActive = this.selected
        this.selected ? this.tabIndex = 0 : this.tabIndex = -1

        if (this.setMaxHeight && this.selected) this.snipContent()
    },

    methods: {
        toggleElementStyles (hideContent) {
            this.el.style.height = hideContent ? `${this.maxHeight}px` : null
            this.el.style.overflow = hideContent ? 'hidden' : null
            this.el.style.marginBottom = hideContent ? '0' : null
        },

        async snipContent () {
            await this.$nextTick()
            const el = this.$refs.tab

            if (this.isActive) {
                this.el = el.querySelector('.content')

                if (this.el && this.el.scrollHeight > this.maxHeight + 30) {
                    this.contentHidden = true

                    this.toggleElementStyles(true)
                }
            }
        },

        scrollToTab () {
            const el = document.getElementById('summary')
            gsap.to(window, {
                duration: .3,
                scrollTo: el.offsetTop - 30,
                ease: 'power3.easeOut'
            })
        },

        toggleExpand (event) {
            if (this.expanded) this.scrollToTab()
            const toggleEl = document.querySelector('.tab__expand-toggle')

            event.target.blur()

            const height = this.expanded ? `${this.maxHeight}px` : 'auto'
            const marginBottom = this.expanded ? 0 : '1em'
            const backgroundSize = this.expanded ? null : 0

            gsap.to(toggleEl, {
                backgroundSize,
                duration: .4,
                ease: 'power4.ease-out'
            })

            gsap.to(this.el, {
                height,
                marginBottom,
                duration: .4,
                ease: 'power4.ease-out'
            })

            this.expanded = !this.expanded
        },

        beforeDestroy() {
            this.contentHidden = false
        },
    }
}
</script>

